import { Stack, Typography, useTheme } from "@mui/material";
import { useAtomValue } from "jotai";
import { LogOut } from "lucide-react";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { SettingsMenuItem } from "web_myplann/More/Components/SettingsMenuItem";
import { useSettingsMenuItems } from "web_myplann/More/Hooks/useSettingsMenuItems";
import { IconBox } from "web_myplann/Shared/Components/IconBox";
import { SectionHeader } from "web_myplann/Shared/Components/SectionHeader";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { useLogOut } from "web_myplann/Shared/Hooks/useLogOut";
import { appInfoState } from "web_myplann/Shared/State/appInfoAtom";

export const MorePage = () => {
	const theme = useTheme();
	const { t } = useResource();
	const appInfoAtom = useAtomValue(appInfoState);
	const { toolItems, settingsItems } = useSettingsMenuItems();
	const { logOut } = useLogOut();

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.surface.muted}
			topBar={
				<NavigationHeader
					title={t(Resources.Settings.title)}
					bgColor={theme.palette.background.paper}
					defaultRoute={Routing.Dashboard.path()}
				/>
			}
		>
			<Stack minHeight="100%">
				<SectionHeader title={t(Resources.Settings.Sections.Tools)} />
				<Stack bgcolor={theme.palette.background.paper}>
					{toolItems.map((item, index) => (
						<SettingsMenuItem
							key={item.label}
							item={item}
							showDivider={index < toolItems.length - 1}
						/>
					))}
				</Stack>

				<SectionHeader title={t(Resources.Settings.Sections.Settings)} />
				<Stack bgcolor={theme.palette.background.paper}>
					{settingsItems.map((item, index) => (
						<SettingsMenuItem
							key={item.label}
							item={item}
							showDivider={index < settingsItems.length - 1}
						/>
					))}
				</Stack>

				<Stack bgcolor={theme.palette.background.paper} mt={2}>
					<Stack
						direction="row"
						alignItems="center"
						gap={1.6}
						px={1.6}
						py={1.2}
						onClick={logOut}
						sx={{
							cursor: "pointer",
							"&:active": { bgcolor: theme.palette.surface.muted },
						}}
					>
						<IconBox bg={theme.palette.red[100]} shape="circle">
							<LogOut size={theme.iconSize.md} color={theme.palette.red[600]} />
						</IconBox>
						<Typography
							variant="subtitle1"
							color={theme.palette.red[500]}
							flex={1}
						>
							{t(Resources.Settings.LogOut)}
						</Typography>
					</Stack>
				</Stack>

				<Stack alignItems="center" py={3}>
					<Typography variant="hint">
						{`myPLANN ${appInfoAtom.appVersion}`}
					</Typography>
					<Typography variant="hint" mt={0.5}>
						{t(Resources.Settings.Copyright)}
					</Typography>
				</Stack>
			</Stack>
		</MyPlannLayout>
	);
};
